import { render } from "./MultimediaSection.vue?vue&type=template&id=688a5bc9&scoped=true"
import script from "./MultimediaSection.vue?vue&type=script&lang=js"
export * from "./MultimediaSection.vue?vue&type=script&lang=js"

import "./MultimediaSection.vue?vue&type=style&index=0&id=688a5bc9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688a5bc9"]])

export default __exports__